import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    peerConfiguration : [],
    loading : false,
    error : null,
};

const peerConfigurationSlice = createSlice({
    name:"peerConfiguration",
    initialState,
    reducers: {
        fetchpeerConfigurationSuccess: (state,action) => {
            state.loading = false;
            state.peerConfiguration = action.payload;
        },
        fetchpeerConfigurationFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    },
})

export const {
    fetchpeerConfigurationSuccess,
    fetchpeerConfigurationFailure
} = peerConfigurationSlice.actions

export default peerConfigurationSlice.reducer